"use client"

import DeploymentForm from "@/components/DeploymentForm"

export default function DeployPage() {
    return (
        <>
            {/**
             * TODO: use component props onSubmit & isLoading
             */}
            <DeploymentForm />
        </>
    )
}